import { COLOR_KEYS_LIST } from '../../constants';
import { createBuilderModule } from '../../builder';
import { iconNames } from '../../global/types';
import { BlockGridItem } from './BlockGridItem';
import { videoInputs } from '../Video/Video.builder';

export default createBuilderModule(BlockGridItem, {
  name: 'BlockGridItem',
  image: 'https://cdn.zappy.app/213f0a68702998508b364f372a5f2f5f.png',
  inputs: [
    // Icon
    {
      name: 'iconName',
      type: 'string',
      enum: ['', ...Object.keys(iconNames)],
    },
    {
      name: 'iconColor',
      type: 'string',
      enum: COLOR_KEYS_LIST,
      showIf: (options) => !!options.get('iconName'),
    },

    // Media
    {
      name: 'imageUrl',
      type: 'cloudinaryImage',
    },
    {
      name: 'imageAltText',
      type: 'string',
    },
    {
      name: 'video',
      type: 'object',
      subFields: videoInputs,
    },

    // Heading
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Example heading',
    },

    // Description
    {
      name: 'description',
      type: 'richText',
      defaultValue: '<p>Example content...</p>',
    },

    // Small text
    {
      name: 'smallText',
      type: 'string',
    },

    // Primary CTA
    {
      name: 'ctaText',
      type: 'string',
    },
    {
      name: 'ctaHref',
      type: 'string',
    },

    // Secondary CTA
    {
      name: 'secondaryCtaText',
      type: 'string',
    },
    {
      name: 'secondaryCtaHref',
      type: 'string',
    },

    // Toggles
    {
      name: 'isLink',
      friendlyName: 'Make entire block clickable',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'isCentered',
      friendlyName: 'Center align content',
      type: 'boolean',
      defaultValue: false,
    },
  ],
});
